module.exports = __webpack_public_path__ + "static/media/clue06.6a84397d.png";